export class PromotoraParecerDTO {
  public id!: number;
  public idPromotora!: number;
  public parecer!: string;
  public idUsuario!: number;
  public nomeUsuario!: string;
  public dtInclusao!: Date;
}
